/**
 * Popup on hover.
 */

export const initPopupOnHover = () => {
	// eslint-disable-next-line no-undef
	const { popupOnHover } = fbVars;
	if ( typeof popupOnHover !== 'undefined' ) {
		const popupOnHovers = document.querySelectorAll( '.popup-on-hover' );
		if ( popupOnHovers ) {
			const popupOnHoversLength = popupOnHovers.length;
			for ( let i = 0; i < popupOnHoversLength; ++i ) {
				popupOnHovers[ i ].removeAttribute( 'title' ); // Remove placeholder "title" attribute that serves for admin only.
				const templateName = popupOnHovers[ i ].dataset.popupOnHoverTemplate;
				if ( templateName ) {
					const foundTemplate = popupOnHover.find(
						( item ) => item.popup_on_hover_templates_name === templateName
					);
					if ( foundTemplate ) {
						const templateNode = document.createElement( 'div' );
						templateNode.classList.add( 'popup-on-hover__popup' );
						templateNode.innerHTML = foundTemplate.popup_on_hover_templates_template;
						popupOnHovers[ i ].appendChild( templateNode );
					}
				}
			}
		}
	}
};
